import {
  ActivityTypeValue,
  ObjectiveStatus
} from '../../../../utils/constants';
import { getBgColor, getColor } from '../../../../utils/objectives.utils';

export const quickTipsModal = {
  title: 'Sample tips to write action steps',
  tips: [
    'Break it down: Divide your goal into smaller, manageable action steps. Make it easier to track progress and take incremental steps towards the larger goal.',
    'Be specific: Clearly state what you will do, how you will do it, and when you will complete it.',
    'Update and Reflect: Regularly review your action steps and update them if needed.',
    'Seek feedback: Share your growth plan and action steps with your mentor/manager. Their feedback can provide guidance and help you refine your approach.'
  ],
  cta: 'Done'
};

export const ObjectiveStatusLabelColorMapping = {
  NOT_STARTED: {
    color: getColor(ObjectiveStatus.NOT_STARTED),
    bgColor: getBgColor(ObjectiveStatus.NOT_STARTED),
    label: ActivityTypeValue.NOT_STARTED,
    graphColor: '#757575'
  },
  OFF_TRACK: {
    color: getColor(ObjectiveStatus.OFF_TRACK),
    bgColor: getBgColor(ObjectiveStatus.OFF_TRACK),
    label: ActivityTypeValue.OFF_TRACK,
    graphColor: '#D66561'
  },
  NEEDS_WORK: {
    color: getColor(ObjectiveStatus.NEEDS_WORK),
    bgColor: getBgColor(ObjectiveStatus.NEEDS_WORK),
    label: ActivityTypeValue.NEEDS_WORK,
    graphColor: '#DEA964'
  },
  ON_TRACK: {
    color: getColor(ObjectiveStatus.ON_TRACK),
    bgColor: getBgColor(ObjectiveStatus.ON_TRACK),
    label: ActivityTypeValue.ON_TRACK,
    graphColor: '#5EB07C'
  },
  DROPPED: {
    color: getColor(ObjectiveStatus.DROPPED),
    bgColor: getBgColor(ObjectiveStatus.DROPPED),
    label: ActivityTypeValue.DROPPED,
    graphColor: '#9CA3AF'
  },
  ACHIEVED: {
    color: getColor(ObjectiveStatus.ACHIEVED),
    bgColor: getBgColor(ObjectiveStatus.ACHIEVED),
    label: ActivityTypeValue.ACHIEVED,
    graphColor: '#627AA6'
  },
  NOT_ACHIEVED: {
    color: getColor(ObjectiveStatus.NOT_ACHIEVED),
    bgColor: getBgColor(ObjectiveStatus.NOT_ACHIEVED),
    label: ActivityTypeValue.NOT_ACHIEVED,
    graphColor: '#9982DA'
  }
};
